module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.wrapClasses
  }, [_c('div', {
    class: _vm.handlerClasses
  }, [_c('a', {
    class: _vm.upClasses,
    on: {
      "click": _vm.up,
      "mouse": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.preventDefault($event)
      }
    }
  }, [_c('span', {
    class: _vm.innerUpClasses,
    on: {
      "click": _vm.preventDefault
    }
  })]), _vm._v(" "), _c('a', {
    class: _vm.downClasses,
    on: {
      "click": _vm.down,
      "mouse": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.preventDefault($event)
      }
    }
  }, [_c('span', {
    class: _vm.innerDownClasses,
    on: {
      "click": _vm.preventDefault
    }
  })])]), _vm._v(" "), _c('div', {
    class: _vm.inputWrapClasses
  }, [_c('input', {
    class: _vm.inputClasses,
    attrs: {
      "disabled": _vm.disabled,
      "autocomplete": "off",
      "autofocus": _vm.autofocus,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "keydown": function($event) {
        $event.stopPropagation();
        _vm.keyDown($event)
      },
      "change": _vm.change
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c73ff7aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/input-number/input-number.vue
// module id = 668
// module chunks = 1